import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import CloneWeekForm from './CloneWeekForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';
class CloneWeekDialog extends Component {
    constructor(props) {
        super(props);
    }

    dialogConfig() {
        const { t, onCancel, week } = this.props;

        return {
            header: t('WorkshopSession_CloneWeek', { sourceWeek: week && week.name }),
            body: this.renderBody(),
            onHide: onCancel,
            footer: this.renderFooter()
        };
    }

    renderBody() {
        const { onConfirm, week } = this.props;
        return <CloneWeekForm onSubmit={onConfirm} initialValues={{ weekId: week && week.id }} />;
    }

    renderFooter() {
        const { onCancel, t } = this.props;

        const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
        const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='cloneWeek' label={t('Workshiop_Clone')} />;

        return [closeBtn, confirmBtn];
    }

    render() {
        const { show, block, unblock } = this.props;
        const dialogConfig = this.dialogConfig();
        return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
    }
}

CloneWeekDialog.propTypes = {
    show: PropTypes.bool,
    to: PropTypes.array,
    block: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    unblock: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(CloneWeekDialog);